// src/services/analyticsService.js
import { getAnalytics, logEvent } from "firebase/analytics";
import { app } from "./firebase.js";

/**
 * @file This service provides functions for logging analytics events to Firebase Analytics.
 */

const analytics = getAnalytics(app);

/**
 * Logs a screen view event to Firebase Analytics.
 *
 * @param {string} screenName - The name of the screen.
 */
export const logScreenView = (screenName) => {
  if (analytics) {
    logEvent(analytics, 'screen_view', {
      screen_name: screenName,
      screen_class: screenName,
    });
  }
};

/**
 * Logs a custom analytics event to Firebase Analytics.
 *
 * @param {string} eventName - The name of the event.
 * @param {object} params - The event parameters.
 */
export const logAnalyticsEvent = (eventName, params) => {
  if (analytics) {
    logEvent(analytics, eventName, params);
  }
};

/**
 * Logs when a user is identified as a beta user.
 *
 * @param {string} userId - The user's ID.
 */
export const logBetaUserIdentified = (userId) => {
  logAnalyticsEvent('beta_user_identified', {
    user_id: userId,
    user_type: 'beta'
  });
};

/**
 * Logs when a beta user is transitioned to trial status.
 *
 * @param {string} userId - The user's ID.
 */
export const logBetaUserTransitioned = (userId) => {
  logAnalyticsEvent('beta_user_transitioned', {
    user_id: userId,
    from_status: 'beta',
    to_status: 'trialing'
  });
};

/**
 * Logs when a user signs up during beta period.
 *
 * @param {string} userId - The user's ID.
 */
export const logBetaSignup = (userId) => {
  logAnalyticsEvent('beta_signup', {
    user_id: userId,
    signup_type: 'beta'
  });
};
